// src/config/stairDetailsConfig.js

export const stairDetails = {
    'central-stringer': `**Stairs Stringer**
**- **Site survey
- Shop drawings 
- 150 x 100 x 6mm rectangular hollow section central stringer If under 4.5M span 
- 150 x 100 x 9 or 200 x 100 x 6 rhs stringer if over 4.5M span 
- 75 x 5 shs stubs 
- 700 x 200 x 12mm horizontal mild steel tread plates plug welded to stub from above (no visible welds).
- All components to be powder-coated in standard Dulux (colour TBC).
- Chemset or bolted connections to floor and upper boundary 
 
**Timber Treads**
- Solid timber made from vertical laminations 
- 80- 90mm thick 
- Raw sanded finish 
- Stair Treads with 5mm Radius on all edges
- Rebated tread for steel plates
- Bona Polyurethane sealer

**Installation**
- Installation of the above components.
- Hiab delivery for steel 
- Timber treads installed near end of build 
 
**No allowance in this quote for the following.**
- Structural alterations to the property.
- Glass balustrade or glass fittings
- Handrail 
- Under panels (to hide steel fixing plate)
- End caps (to hide glass pin fixing )
- Top nosing on boundary joist 
- Colour matched stain
- Building work or jack studs under steel lintels 
- Wrapping or protecting treads after installation
- Large crane install 
- LED's or LED Rebates 

**Notes**
- With a landing selected stairs, landing will be the same width as the treads. If a different size is required, SW will update Quotation. 
- All pricing is subject to engineering and site measure
- Install Auckland wide 
- Additional cost will be applied for jobs outside of Auckland 
- If the price does not fall inside the project Budget please Call SW for cheaper options such as 
-- Bamboo treads
-- SW can make treads from Client supplied flooring 
-- Multiple project discounts 
-- Winders instead of landings  
- If a PS1 is required -  cost is approx $2300 plus gst`,
    
    'cantilever': `**Cantilever Stair**
Stairs Stringer 
 
- 200 x 100 x 9mm mild steel RHS stringer concealed within 140 stud wall framing.
- 16mm mild steel stiffening plates welded to the face of the RHS stringer at each tread location.
- 2 no. 89 SHS posts fixed between 1st floor double joists and ground floor slab concealed within wall framing for stringer connection.
- All structure in wall framing is concealed by gib finish (gib lining by others).
- 15 no. treads, structure formed from 2 no. 100 x 50 x 6mm RHS outriggers with a 10mm fixing plate at stringer end, and 75 x 50 x 6mm UA bracket at balustrade end.
- Treads to be installed via mechanical fixing to achieve alignment, then welded in-situ. 
-  Hollow box treads formed from USA oak to conceal steel outriggers.
 - All steel work is primed.
- Chemset or bolted connections to floor and upper boundary 

Timber Treads 
-  Hollow box treads formed from USA oak to conceal steel outriggers.
- Solid timber made from vertical laminations 
- 80- 90mm thick 
- 13mm thick oak veneered MDF under panels fixed into rebates on the underside of box treads
- Raw sanded finish 
- Stair Treads with 5mm Radius on all edges
- Rebated tread for steel plates
- Bona Polyurethane sealer


 Installation
- Installation of the above components.
- Hiab delivery for steel 
 -Timber treads installed near end of build 

No allowance in this quote for the following. 
- Structural alterations to the property.
- Glass balustrade or glass fittings
- Handrail 
- Under panels (to hide steel fixing plate)
- End caps (to hide glass pin fixing )
- Top nosing on boundary joist 
- Colour matched stain
- Building work or jack studs under steel lintels 
- Wrapping or protecting treads after installation
- Large crane install 
- LED lighting or LED rebates 
- Pocket cut into framing ( by builder) 


Notes 
- With a landing selected stairs, landings will be the same width as the treads. If a different size is required, SW will update Quotation. 
- All pricing is subject to engineering and site measure 
- Cantilever stairs will have to be connected to a 140mm framed wall rather than 90mm
- Stairwork to provide template form builder to cut out pocket in Wall 
- Install Auckland wide 
- Additional cost will be applied for jobs outside of Auckland 
- If the price does not fall inside the project Budget please Call SW for cheaper options such as 
-- Bamboo treads
-- SW can make treads from Client supplied flooring 
-- Multiple project discounts 
-- Winders instead of landings  
- If a PS1 is required -  cost is approx $2300 plus gst`,
    
    'Spiral': `**Spiral Stair**
Spiral staircase and landing
- Landing to  connect to deck boundary joist 
- 200 x 6mm rolled mild steel stringer
- Folded 5mm mild steel tread (chequer plate or flat steel finish)
- 139.7 x 5.4mm CHS Center pole

Balustrade 
- 16mm spindles top fixed to treads 
- 40x 12 top rail 
 
Finish on all Internal steel work
1) Sand Blast SA2.5,
2) Powder Coated standard dulux colour

Finish on all External steel work
Finish on all steel work
1) Sand Blast SA2.5,
2) Zinc metal spray@100microns, sealer
3) Epoxy primer 220@75microns
4) Top coat Uracryl 2xcoats@50microns each
-Total 275microns Cover
 
 Installation
- Installation of the above components.
- Hiab delivery for steel 
 -Timber treads installed near end of build 

No allowance in this quote for the following. 
- Structural alterations to the property.
- Glass balustrade or glass fittings
- Handrail 
- TImber treads 
- Top nosing on boundary joist 
- Building work 
- Wrapping or protecting treads after installation
- Large crane install 
- LED lighting or LED rebates 

Notes 
- With a landing selected stairs, landings will be the same width as the treads. If a different size is required, SW will update Quotation. 
- All pricing is subject to engineering and site measure 
- Install Auckland wide 
- Additional cost will be applied for jobs outside of Auckland 
- Spiral floor plan area required can only be worked out after Site visit 1.8 x 1.8 is approx
- If a PS1 is required -  cost is approx $2300 plus gst`
};